import '@mdi/font/css/materialdesignicons.css'
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { en } from 'vuetify/locale'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import App from './App.vue'
import router from './router'
import { useAppStore } from './stores/app'

function getUserLocale() {
  return navigator.language || navigator.userLanguage || 'en-NZ'
}

const vuetify = createVuetify({
  components: {
    ...components,
  },
  directives,
  icons: {
    iconfont: 'md', // Use Material Design Icons
  },
  locale: {
    locale: 'en', // Set the default locale
    fallback: 'en', // Set the fallback locale
    messages: { en }, // Add the imported locale
  },
  options: {
    keyboardDate: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  },
  date: {
    locale: {
      en: getUserLocale(),
    },
  },
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(vuetify)
app.use(pinia)
app.use(router)

const appStore = useAppStore()

// Fetch CSRF token before mounting the app
appStore.fetchToken().then(async () => {
  app.mount('#app')
})
